import FetchContent from './fetchContent';

class FetchSnippets extends FetchContent {
  async run() {
    this.response = await this.model.fetch(`snippets/${this.url}`);
    return this.response;
  }
}
export default FetchSnippets;
